export const formatString = (str) => {
  if (typeof str !== 'string') {
    return '';
  }

  return str
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const formatDate = (dateString) => {
  if (!dateString) return '';

  const [year, month, day] = dateString.split('-');
  return `${day}-${month}-${year}`;
};


// // utils.js
// export const getActiveMenu = (path) => {
//   const solutionPaths = [
//     '/ecommerce-solution', 
//     '/edtech', 
//     '/small-to-medium-business', 
//     '/corporate', 
//   ];
//   const servicePaths = [
//     '/web-application', 
//     '/software-development', 
//     '/mobile-application', 
//     '/creative', 
//     '/digital-marketing-and-seo', 
//     '/domain-and-hosting',
//     '/consultancy'
//   ];
//   const companyPaths = [
//     '/our-clients', 
//     '/our-technology-partners', 
//     '/about-us-pages', 
//     '/career', 
//     '/testimonials', 
//     '/faq', 
//     '/our-teams'
//   ];
//   const helpCenterPaths = [
//     '/knowledge-base', 
//     '/contact-us'
//   ];

//   if (solutionPaths.includes(path)) {
//     return '/solution';
//   } else if (servicePaths.includes(path)) {
//     return '/service';
//   } else if (companyPaths.includes(path)) {
//     return '/about-us';
//   } else if (helpCenterPaths.includes(path)) {
//     return '/help-center';
//   } else {
//     return '';
//   }
// };



// utils.js
export const getActiveMenu = (path) => {
  if (path.startsWith('/contact-us') || 
    path.startsWith('/knowledged-base')
  ) return '/help-center';

  if (
    path.startsWith('/ecommerce-solution') || 
    path.startsWith('/edtech') ||
    path.startsWith('/small-to-medium-business') ||
    path.startsWith('/corporate')
  ) return '/solution';

  if (
    path.startsWith('/web-application') ||
    path.startsWith('/software-development') ||
    path.startsWith('/mobile-application') ||
    path.startsWith('/creative') ||
    path.startsWith('/digital-marketing-and-seo') ||
    path.startsWith('/domain-and-hosting') ||
    path.startsWith('/consultancy')
  ) return '/service';

  if (
    path.startsWith('/our-clients') ||
    path.startsWith('/our-technology-partners') ||
    path.startsWith('/about-us-pages') ||
    path.startsWith('/career') ||
    path.startsWith('/testimonials') ||
    path.startsWith('/faq') ||
    path.startsWith('/our-teams')
  ) return '/company';

  return '';
};
 